import jsPDF from "jspdf";
import moment from "moment";

export const validateEmailFomat = (value) => {
    // Simple regex for basic email validation
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(value);
  };



export const generateBookingPDF = (contactData) => {
  const doc = new jsPDF("p", "mm", "a4");

  const fullName = `${contactData.firstName} ${contactData.lastName}`;
  const purpose = contactData.purposeOfConsultation;
  const todayDate = moment().format("DD MMM YYYY");

  let y = 20; // vertical cursor

  // ===== Title =====
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Initial Consultation Agreement", 105, y, { align: "center" });

  y += 12;

  // ===== Intro =====
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text(
    "This Agreement outlines the terms of consultation services provided by Sujeet Dahiya, " +
      "a Regulated Canadian Immigration Consultant (RCIC #R713068), to the Client.",
    20,
    y,
    { maxWidth: 170 }
  );

  y += 14;

  // ===== Clause 1 =====
  doc.setFont("helvetica", "bold");
  doc.text("1. Purpose of Consultation", 20, y);
  y += 8;

  doc.setFont("helvetica", "normal");
  doc.text(
    `The purpose of an Initial consultation is to provide the consultant with sufficient information ` +
      `to allow for a full analysis and comprehensive advice on immigration options, including estimated ` +
      `timeframes, legal fees, and costs for ${purpose}.`,
    20,
    y,
    { maxWidth: 170 }
  );

  y += 18;

  // ===== Clause 2 =====
  doc.setFont("helvetica", "bold");
  doc.text("2. Fees", 20, y);
  y += 8;

  doc.setFont("helvetica", "normal");
  doc.text("The Client is obliged to pay the full fee in CAD.", 20, y);

  y += 14;

  // ===== Clause 3 =====
  doc.setFont("helvetica", "bold");
  doc.text("3. Limited Scope", 20, y);
  y += 8;

  doc.setFont("helvetica", "normal");
  doc.text(
    "No Consultant-Client relationship is intended to be established by the consultation agreement. " +
      "At the conclusion of initial consultation there is no obligation for you to retain us, nor do we " +
      "have an obligation to provide any services to you, unless further engagement or full retainer " +
      "agreement is signed.",
    20,
    y,
    { maxWidth: 170 }
  );

  y += 22;

  // ===== Clause 4 =====
  doc.setFont("helvetica", "bold");
  doc.text("4. Method of Consultation", 20, y);
  y += 8;

  doc.setFont("helvetica", "normal");
  doc.text(
    "RCIC shall provide consultation to the client in person or by phone. The consultation will last " +
      "for such period of time as necessary for RCIC to perform the services under this agreement, but " +
      "in any event, shall not be longer than 20 minutes.",
    20,
    y,
    { maxWidth: 170 }
  );

  y += 22;

  // ===== Clause 5 =====
  doc.setFont("helvetica", "bold");
  doc.text("5. Confidentiality", 20, y);
  y += 8;

  doc.setFont("helvetica", "normal");
  doc.text(
    "Any information or documentation reviewed by the RCIC in the course of the consultation, will not " +
      "be divulged to any third party, other than RCIC’s agents and employees, without any prior consent " +
      "of the client except as demanded by the law.",
    20,
    y,
    { maxWidth: 170 }
  );

  y += 22;

  // ===== Clause 6 =====
  doc.setFont("helvetica", "bold");
  doc.text("6. Validation", 20, y);
  y += 8;

  doc.setFont("helvetica", "normal");
  doc.text(
    "This Agreement shall be governed by the laws in effect in the Province of Ontario and the federal " +
      "laws of Canada applicable therein. Please be advised that Sujeet Dahiya is a member in good standing " +
      "of the College of Immigration and Citizenship Consultants (CICC), and as such, is bound by its " +
      "By-law, Code of Professional Ethics, and Regulations.",
    20,
    y,
    { maxWidth: 170 }
  );

  y += 26;

  // ===== Clause 7 =====
  doc.setFont("helvetica", "bold");
  doc.text("7. Acknowledgment", 20, y);
  y += 8;

  doc.setFont("helvetica", "normal");
  doc.text(
    "By clicking below and paying the consultation fee through the booking tool, the Client acknowledges " +
      "that they have read, understood, and agreed to be bound by all the terms and conditions of this Agreement.",
    20,
    y,
    { maxWidth: 170 }
  );

  y += 22;

  // ===== Signature Section =====
  doc.text(`${fullName} (Name)`, 20, y);
  doc.text(`${todayDate} (Date)`, 130, y);

  y += 14;

  doc.text(
    "I agree by typing my name, I am electronically signing this agreement.",
    20,
    y
  );

  return doc.output("blob"); // 🔥 Upload-ready
};
